<template>
  <transition name="fades">
    <div class="leon_alter" style="z-index: 2001" v-if="show" @mousewheel.prevent @scroll.stop.prevent>
      <div class="leon_alter_box">
        <div class="title bold">{{title}}</div>
        <div class="text">{{text}}</div>
        <div v-if="img" class="img">
          <img :src="img" alt="" srcset="">
        </div>
        <div class="btn">
          <el-button type="primary" round @click="yesBtn">{{yesTxt}}</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LeonAlter',
  data () {
    return {
      show: false,
      title: '',
      text: '',
      yesTxt: '确定',
      img: '',
      click: null,
      confirm: null
    }
  },
  methods: {
    yesBtn () {
      this.confirm && this.confirm()
      this.click && this.click()
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.leon_alter{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .leon_alter_box{
    background: #FFFFFF;
    border-radius: 16px;
    text-align: center;
    width: 402px;
    padding: 32px;
    .title{
      font-size: 20px;
      line-height: 26px;
    }
    .img{
      img{
        width: 100%;
      }
    }
    .text{
      font-size: 16px;
      line-height: 21px;
      margin-top: 16px;
      white-space: pre-wrap;
      word-break: break-word;
    }
    .btn{
      margin-top: 24px;
    }
  }
}
body{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/plugin/leonAlter/src/main.vue